import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { renderTime } from 'utils/functions';
import Avatar from 'components/Avatar';
import { VerifiedIcon } from 'components/Icons';
import notificationTypes from 'constants/notificationTypes';
import { USER_PROFILE, SINGLE_POST } from 'constants/routes';
import SubscribeComponent from 'components/generic-components/SubscribeComponent';

const Notification = ({ notification }) => {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const time = renderTime(notification.createdAt);
    const isTip = useMemo(() => notification.type === 'tip_received', [notification.type]);
    const postId = useMemo(() => notification.post_id, [notification.post_id]);
    const getText = useMemo(() => t(notificationTypes[notification.type].text), [notification,  i18n.language]);

    const handleClick = () => {
        if (['post_created', 'post_commented', 'post_liked'].includes(notification.type)) {
            history.push(SINGLE_POST.replace(':id', notification.object_id));
        }
        if (isTip && postId) {
            history.push(SINGLE_POST.replace(':id', postId));
        }
        if (['user_followed'].includes(notification.type)) {
            history.push(USER_PROFILE.replace(':userId', notification.object_id));
        }
    };
    
    return (
        <li className="list-group-item list-group-item-action cursor-pointer bg-dark notification-container">
            <div className="d-flex flex-1 notification-content-container">
                <div className={'d-flex notification-left-container'}
                    onClick={handleClick}>
                    <Avatar size={48} image={notification.sender.user.avatar} user={notification.sender.user && notification.sender.user.name} />
                    <div className={'ml-2 notification-info-container'} style={{ position: 'relative' }}>
                    {!notification.read_at && <div className="notification-readat" style={{ position: 'absolute' }}></div>}
                        <div className="d-flex user-name-verified-container">
                            <p className={'font-size-12 text-light'}> <b>{notification.sender.user.name}</b> </p>
                            {!!notification.sender.verification_status === "verified" && (
                                <VerifiedIcon height="1rem" width="1rem" className="fill-grey ml-1 header-icon-grey" />
                            )}
                        </div>
                        <p className={'font-size-12 text-purple notifications-type'}>
                            {getText}
                            {isTip && <strong className="tip-amount"> ₪{notification.tip.amount}</strong>}
                            {postId && (
                                <>{t(' under ')} <br />{t(' this ')}<span className="notification-tip-link" onClick={handleClick}>{t(' post ')}</span></>
                            )}
                        </p>
                        {
                            notification.type === 'tip' && (
                                <React.Fragment>
                                    {!!notification.message && (
                                        <p>
                                            <b>{t('Message')}:</b> {notification.message}
                                        </p>
                                    )}
                                    <small className="text-light-gray d-block">
                                        {t('Amount')}: ${notification.amount}
                                    </small>
                                </React.Fragment>
                            )
                        }
                        <small className="notifications-date text-light-gray">  {time.actualTime} {time.text}</small>
                    </div>
                </div>
                <SubscribeComponent showDot={false} />
            </div>
        </li>
    )
}
export default Notification;
